import { FC } from 'react';
import './skeleton.scss';

type SkeletonProps = {
    width?: string;
    height?: string;
    className?: string;
};

export const Skeleton: FC<SkeletonProps> = ({ width = '', height = '', className = '' }) => {
    return <div style={{ width, height }} className={`skeleton ${className}`} />;
};
